import React from 'react';

import {ChangeRequestContextualLink} from 'src/openapi/models/ChangeRequestContextualLink';

import {FlatButton} from '@pb/kit-component-button';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

type Props = {
    contextualLink: ChangeRequestContextualLink,
    onClick: () => void,
};

export const ContextualButtonLink = ({contextualLink, onClick}: Props) => {
    return (
        <FlatButton onClick={onClick} style={{minWidth: 0, maxWidth: '100%'}}>
            <EllipsisTextHint>{contextualLink.title}</EllipsisTextHint>
        </FlatButton>
    );
};
